<template>
  <div class="wrap" v-loading="loading">
    <div class="steps">
      <template v-for="(item, index) in steps">
        <el-link class="step" :key="index" :icon="item.icon" :class="{ current: active == index }" @click="goAnchor(index)">{{ item.title }}</el-link>
      </template>
    </div>
    <el-card shadow="never">
      <component :is="children" />
    </el-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      active: 0,
      steps: [
        { title: "基础信息", icon: 'el-icon-news', com: './_baseinfo.vue' },
        { title: "商品清单", icon: 'el-icon-goods', com: './_items.vue' },
      ]
    }
  },
  created () {
    this.goAnchor(this.index)
  },
  methods: {
    goAnchor (index = 0) {
      this.active = index
      this.children = () => import(`${this.steps[index]['com']}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap {
  max-width: 1024px;
  min-width: 720px;
  .steps {
    background: #fff;
    border-radius: 5px;
    display: flex;
    border: 1px solid rgba(0, 0, 0, 0.1);
    margin-bottom: 16px;
    .step {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 16px;
      position: relative;
      color: #bbb;
    }
    .step.current {
      color: #409eff;
    }
    .step.hide {
      color: #ccc;
    }
    .step + .step::before {
      content: '〉';
      position: absolute;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      color: rgba(0, 0, 0, 0.1);
    }
  }
}
</style>